<template>
  <md-dialog class="supplier-email-box" :md-closed="closeDialog" :md-opened="openDialog" :md-close-on-esc="false" :md-click-outside-to-close="false" :md-active.sync="options.showSendEmailToSupplierForm">
    <div class="email-header-grid">
      <div v-if="!tabOne" class="email-title">
        {{ options.Lang.Email_an_Supplier_versenden + (openMail ? ' | ' + (form.lang === 'de' ? 'DE' : 'EN') : '') }}
      </div>
      <div v-else class="email-title">
        {{ options.Lang.Supplier_Mail_Historie }}
      </div>

      <div class="email-box">
        <SmallInfoBox title="Angebot" :content="trip_details_json?.data.attributes?.alias || ''" />
      </div>

      <div class="email-box">
        <SmallInfoBox :title="'Nezasa ID'" :content="trip ? trip.nezasa_id : ''" :copy="true" />
      </div>
    </div>
    <div class="supplier-tabs">
      <button class="tab-btn" :class="{ active: !tabOne }" @click="tabOne = false">Email an Supplier versenden</button>
      <button class="tab-btn" :class="{ active: tabOne }" @click="tabOne = true">Supplier-Email-Historie</button>
    </div>
    <!--    First Tab   -->
    <md-dialog-content v-if="renderComponent && !tabOne">
      <div class="step-line-wrapper">
        <div class="step-circle step-1" :class="{ active: openMail }" >
          <img v-if="openMail" @click="tabOne = false" src="../../assets/images/icons/edit_step.svg" class="step-icon" style="cursor: pointer;" />
          <span v-else class="step-circle active">1</span>
        </div>
        <div class="step-line"></div>

        <div :class="['step-circle', openMail ? 'active' : '']">2</div>
        <div class="step-line"></div>

        <div class="step-circle">3</div>
      </div>
      <div :class="`pt-30 ${ !openMail ? 'supplier-mail-content' : ''}`">
        <form novalidate class="md-layout" @submit.prevent="validate">
          <div v-if="!openMail" class="md-layout">
            <div v-for="(column, colIndex) in dynamicColumns"
                 :key="'col-' + colIndex"
                 class="md-layout-item"
                 :class="'md-size-' + Math.floor(100 / dynamicColumns.length)">

              <div v-for="category in column"
                   :key="category.key"
                   class="category-block pt-30">

                <label>{{ category.label }}<span class="md-required">*</span></label>
                <ul class="supplier_list">
                  <li v-for="detail in category.items" :key="category.key + detail.id">
                    <md-checkbox :disabled="sending" :value="1" class="md-primary" v-model="detail.check">
                      <span v-if="detail?.anfrage == true">
                        <md-icon class="anfrageIcon" style="font-size: 12px !important;">fiber_manual_record</md-icon>
                      </span>
                      <!-- NAME -->
                      <template v-if="category.key === 'hotels'">
                        {{ detail.name + ', ' + detail.city }}
                      </template>
                      <template v-else>
                        {{ detail.name }}
                      </template>
                      <br>
                      <!-- DATE / EXTRA INFO -->
                      <template v-if="category.key === 'flights'">
                        {{ detail.dayStart + ' - ' + detail.dayEnd + ' ' + detail.airline + ' ' + detail.code + ' ' + detail.class }}
                      </template>
                      <template v-if="category.key === 'ferry'">
                        {{ detail.startDate + ' - ' + detail.endDate }}
                      </template>
                      <template v-if="category.key === 'rental_cars'">
                        {{ detail.date }}
                      </template>
                      <template v-if="category.key === 'activities'">
                        {{ detail.date }}
                      </template>
                      <!-- VENDOR -->
                      <span class="vendor">{{ detail.vendor }}</span>
                    </md-checkbox>
                    <br><br>
                  </li>
                </ul>
              </div>

            </div>
          </div>

          <div v-if="openMail" class="md-layout-item md-size-40 send-email-left-col">
            <div class="md-layout">
              <!-- LEFT INNER COLUMN -->
              <div class="md-layout-item md-size-50 pr-20">
                <div class="pt-30">
                  <md-field class="md-focused supplier-field-left" :class="getValidationClass('cc_email')">
                    <label for="cc_email">{{ options.Lang.Kunde }}</label>
                    <md-input id="cc_email" v-model="form.client_name" :disabled="true"/>
                  </md-field>
                </div>
                <div class="pt-30">
                  <md-field class="md-focused supplier-field-left" :class="getValidationClass('email')">
                    <label for="email">{{ options.Lang.Empfänger_Email }}<span class="md-required">*</span></label>
                    <md-input id="email" v-model="form.email" :disabled="sending"/>
                  </md-field>
                </div>
                <div class="pt-30">
                  <md-field class="md-focused supplier-field-left">
                    <label for="email">{{ options.Lang.Absender || 'Test' }}<span class="md-required">*</span></label>
                    <md-input id="email" v-model="form.sender_name" :disabled="sending"/>
                  </md-field>
                </div>
              </div>
              <!-- RIGHT INNER COLUMN -->
              <div class="md-layout-item md-size-50">
                <div class="pt-30">
                  <md-field class="md-focused supplier-field-right">
                    <label>Supplier<br></label>
                    <md-autocomplete v-model="form.supplier" :md-options="supplierList" @md-changed="getSupplierSelection" @md-selected="setSupplier">
                      <template slot="md-autocomplete-item" slot-scope="{ item }">
                        {{ item.supplier_name }}
                      </template>
                    </md-autocomplete>
                  </md-field>
                </div>
                <div class="pt-30">
                  <md-field class="md-focused supplier-field-right" :class="getValidationClass('cc_email')">
                    <label for="cc_email">CC {{ options.Lang.Empfänger_Email }}</label>
                    <md-input id="cc_email" v-model="form.cc_email" :disabled="sending"/>
                  </md-field>
                </div>
                <div class="pt-30">
                  <md-field class="md-focused supplier-field-right" :class="getValidationClass('reply_email')">
                    <label for="reply_email">{{ options.Lang.Antwort_an }}<span class="md-required">*</span></label>
                    <md-input id="reply_email" v-model="form.reply_email" :disabled="sending"/>
                  </md-field>
                </div>
<!--                <div class="pt-30 mt-20">
                  <md-field class="md-focused">
                    <label for="lang2">{{ options.Lang.Sprache }}</label>
                    <md-select id="lang2" v-model="form.lang" md-dense @md-selected="langSwitched">
                      <md-option v-for="language in availableLanguages" :key="language.value" :value="language.value">
                        {{ language.label }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>-->
              </div>
            </div>
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <div class="pt-30">
                  <md-field class="md-focused">
                    <label for="lang">{{ options.Lang.Sprache }}</label>
                    <md-select id="lang" v-model="form.lang" md-dense @md-selected="langSwitched">
                      <md-option v-for="language in availableLanguages" :key="language.value" :value="language.value">
                        {{ language.label }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
                </div>
            </div>
          </div>
          <div v-if="openMail" class="md-layout-item mt-size-60">
            <div class="">
              <div id="editorContainer" class="email w-100 template_editor" :class="sending ? 'disabled' : ''">
                <div class="right" style="padding-right: 0.8rem !important;">
                  <span @click="editor.chain().focus().toggleBulletList().run()">
                    <md-icon>format_list_bulleted</md-icon>
                  </span>
                  <span @click="editor.chain().focus().toggleBold().run()">
                    <md-icon>format_bold</md-icon>
                  </span>
                  <span @click="editor.chain().focus().toggleUnderline().run()">
                    <md-icon>format_underlined</md-icon>
                  </span>
                  <span @click="editor.chain().focus().undo().run()">
                    <md-icon>undo</md-icon>
                  </span>
                </div>
                <label>E-Mail<span class="md-required">*</span></label>
                <editor-content :editor="editor" v-model="this.email"/>
              </div>
            </div>
          </div>
        </form>
      </div>
    </md-dialog-content>
    <md-dialog-actions v-if="!tabOne" class="mt-20 supplier-actions-border">
      <div v-if="openMail"  class="p-20 float_left float_auto">
        <md-button tabindex="8" class="md-raised secondary" @click="closeEmail">{{options.Lang.Leistungen_bearbeiten}}
        </md-button>
      </div>
      <div v-if="openMail"  class="p-20">
        <md-button tabindex="7" id="sendButton" class="md-raised md-primary" @click="save">{{ options.Lang.Email_abschicken }}</md-button>
      </div>
      <div v-if="!openMail" class="float_left float_auto open-mail-btn">
        <md-button tabindex="8" class="md-raised secondary" @click="closeDialog"><strong>{{options.Lang.Abbrechen}}</strong></md-button>
      </div>
      <div v-if="!openMail" class="p-20 open-mail-btn">
        <md-button tabindex="7"  class="md-raised md-primary" @click="openEmail"><strong>{{options.Lang.Weiter}}</strong></md-button>
      </div>
    </md-dialog-actions>
    <!--    Second Tab   -->
    <md-dialog-content v-if="renderComponent && tabOne">
      <FormTimeline :options="options" :currentTrip="trip"/>
    </md-dialog-content>
    <md-dialog-actions class="mt-20 supplier-actions-border" v-if="tabOne">
      <div class="float_left float_auto open-mail-btn">
        <md-button tabindex="8" class="md-raised secondary" @click="closeDialog"><strong>{{options.Lang.close_window}}</strong></md-button>
      </div>
    </md-dialog-actions>
    <Success :options="options"></Success>
  </md-dialog>
</template>

<script>
import * as moment from "moment";
import {validationMixin} from 'vuelidate'
import stringMixin from '@/mixins/stringMixin'
import {Editor, EditorContent} from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import Image from '@tiptap/extension-image'
import Success from '../../components/dialogs/Success.vue'
import Document from '@tiptap/extension-document'
import Gapcursor from '@tiptap/extension-gapcursor'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import Table from '@tiptap/extension-table'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import TableRow from '@tiptap/extension-table-row'
import NezasaIdBox from '../../components/parts/NezasaIdBox.vue'
import SmallInfoBox from '../../components/parts/SmallInfoBox.vue'
import FormTimeline from '../../components/dialogs/FormTimeline.vue'

import {
  required,
} from 'vuelidate/lib/validators'

export default {
  name: 'formSendTripToSuppier',
  mixins: [validationMixin, stringMixin],
  components: {
    EditorContent, Success, NezasaIdBox, SmallInfoBox, FormTimeline
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    currentTrip: {
      type: Object
    },
  },
  data: () => ({
    savedOfferID: null,
    kommentsFromDb: [],
    trip_details_json: null,
    reisedesigner: null,
    brand: null,
    checkedList: null,
    suppliersig_de: null,
    suppliersig_en: null,
    availableLanguages: [],
    mails: [],
    tabOne: false,
    supplierList: [],
    searchSuppliers : [],
    BetreffDe: null,
    BetreffEn: null,
    trip: null,
    go: false,
    reply: null,
    company: null,
    logo: null,
    renderComponent: false,
    suppliers: [],
    fullTimeline: [],
    itinerary: null,
    email: '',
    puffer: null,
    openMail: false,
    editor: new Editor({
      content: '',
      extensions: [
        StarterKit,
        //Underline,
        Image,
        Document,
        Paragraph,
        Text,
        Gapcursor,
        Table.configure({
          resizable: true,
        }),
        TableRow,
        TableHeader,
        TableCell
        // Link.configure({
        //   openOnClick: false,
        //   })
      ],
      }),
    form: {
      client_name: null,
      lang: 'en',
      email: null,
      cc_email: null,
      reply_email: '',
      sender_name: null,
      supplier: '',
      supplierid: 0,
      supplier_gender: null,
    },
    tripDetails: {
      travelers: [],
      shuttles: [],
      hotels: [],
      activities: [],
      rental_cars: [],
      flights: [],
      ferry: []
    },
    tripSaved: false,
    sending: false,
    accoDetails: [],
    accoDetailsEn: [],
    accoLanguage: [],
    accoCheck: 0
  }),
  computed: {
    dynamicColumns() {
      const categories = [];

      const pushIfHasItems = (key, label, items) => {
        if (items && items.length > 0) {
          categories.push({ key, label, items });
        }
      };

      pushIfHasItems('flights', this.options.Lang.Flüge, this.tripDetails.flights);
      pushIfHasItems('ferry', this.options.Lang.Transfers, this.tripDetails.ferry);
      pushIfHasItems('rental_cars', this.options.Lang.Auto, this.tripDetails.rental_cars);
      pushIfHasItems('hotels', this.options.Lang.Hotels, this.tripDetails.hotels);
      pushIfHasItems('activities', this.options.Lang.Aktivitäten, this.tripDetails.activities);

      const maxColumns = 3;
      const columnCount = Math.min(categories.length, maxColumns);

      const columns = Array.from({ length: columnCount }, () => []);

      categories.forEach((cat, i) => {
        columns[i % columnCount].push(cat);
      });

      return columns;
    }
  },
  validations: {
    form: {
      email: {required},
      reply_email: {required},
      sender_name: {required},
    }
  },
  created() {
  
  },
  updated(){
    if(this.form.email == null || this.form.email == ""){
      let button = document.getElementById("sendButton")
      if(button){
        button.setAttribute("disabled", true)
      }
    }else{
      let button = document.getElementById("sendButton")
      if(button){
        button.removeAttribute("disabled")
      }
    }
  },
  async mounted() {
    this.trip = this.currentTrip;
    this.trip_details_json = await this.loadJsonField('trip_details', this.trip.json_path);
    await this.getUserToTrip(this.trip_details_json?.data?.id);
    this.getTimelineMark();
    this.getGlobalInfo();

    this.form.sender_name = this.options.user.firstname + ' ' + this.options.user.lastname
    this.getAllSuppliersForEmail();
    this.getAccoDetails();
    await this.getFullTrip();
  },
  watch: {
    currentTrip: {
      handler(newValue) {
        if (newValue) {
          let self = this;
          self.trip = newValue ? newValue : null;
          self.form.id = newValue ? newValue.id : null;
          self.form.client_name = newValue ? newValue.client_name : null;
          self.getKommentare();
          self.getTripDetails();
        }
      },
      deep: true,
      immediate: true,
    },
    brand: {
      handler(newValue){
        if(newValue){
          this.getBrandingInfos();
          }
      }
    }
  },
  methods: {
    // Supplier signature/subject with all [variables] filled — no data → empty, never raw "[...]".
    fillSupplierVars (text, tripJson) {
      return this.replaceTemplatePlaceholders(text || '', tripJson, {
        lang_code: this.form.lang,
        general: this.options,
        globalinfo: {},
        reisedesigner: this.reisedesigner,
        tripUrl: process.env.VUE_APP_CLIENT_URL,
        loginCode: this.trip?.loginCode
      });
    },
    async getUserToTrip (id) {
      let self = this;
      if (!id) return;
      await self.doPost({ data: id }, 'getUserToTrip', function (res) {
        if (res.data.status !== 'error') {
          self.reisedesigner = res.data.data[0] || null;
        }
      });
    },
    async getFullTrip(){
    let self = this;
      await this.doPost({data: this.trip.nezasa_id}, 'getPublicTripById', async function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data[0].branding_id;
        self.brand = result
        let myData = {
          id: result
        }
        self.getBrandingInfos();
      }
    });
  },
    async getBrandingInfos(){
      let myData = {
      id: this.brand
    }
    let self = this;
      await this.doPost({data: myData}, 'getSingleBranding', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        if (res.data.data && Array.isArray(res.data.data)) {
          self.availableLanguages = res.data.data.map(item => ({
            value: item.lang_code,
            label: self.options.Lang.lang_code[item.lang_code] || item.lang_code
          }));
        }
        let result = {};
        if (res.data.data && Array.isArray(res.data.data)) {
          const matchingLang = res.data.data.find(item => item.lang_code === self.form.lang);
          result = matchingLang || res.data.data[0] || {};
        }
        self.suppliersig_de  = result.emailSupplierSig || '';
        self.suppliersig_en  = result.emailSupplierSig || '';
        self.BetreffDe = result.emailBetreffSupplier || '';
        self.BetreffEn = result.emailBetreffSupplier || '';

      }
    });
    },
    async getTimelineMark() {
      let self = this;
      self.savedOfferID = self.trip.offer_id;
      await this.doPost({ data: self.trip.offer_id }, 'getTimeline', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let toParse = res.data.data[0].timeline;
          self.mails = JSON.parse(toParse);

        }
      });
    },
    getSupplierSelection (searchTerm) {
        this.supplierList = new Promise(resolve => {
          window.setTimeout(() => {
            if (!searchTerm) {
              resolve(this.suppliers)
            } else {
              const term = String(searchTerm).toLowerCase();
              resolve(this.suppliers.filter(({ supplier_name }) => 
                supplier_name.toLowerCase().includes(term)
              ));
            }
          }, 500)
        })
      },
    async getItineraryDetails(){
      let self = this;
      await this.doPost({data: self.currentTrip.nezasa_id}, 'getItineraryById', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data[0];
        self.itinerary = result;
        
      }    
    });
    },
    async getGlobalInfo(){
      let self = this;
      await this.doPost({}, 'getglobalinfo', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data[0];
        self.company = result.adresse;
        self.reply = result.reply;
        self.logo = result.baseLogo;
      }    
    });
    },
     async getAccoDetails(){
      let tripId = this.trip.nezasa_id;
      let self = this;
      await this.doPost({
        data: tripId
      }, 'getAccoDetails', function (res) {
        self.sending = false;
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data;
          if(result[0]?.accommodations_details) {
            self.accoDetails = JSON.parse(result[0].accommodations_details, "RESULT ACCO DEUTSCH")
            self.accoDetailsEn = JSON.parse(result[0].accommodations_details_en, "RESULT ACCO ENGLISCH")
          }else if(result.accommodations_details){
            self.accoDetails = result.accommodations_details.accommodations
            self.accoDetailsEn = result.accommodations_details_en.accommodations
          }
        }
      });
      this.renderComponent = false;
      //alert("hallo")
        // Wait for the change to get flushed to the DOM
        await this.$nextTick();

        // Add the component back in
        //this.renderComponent = true;
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    async clearTripdetails(){
      this.tripDetails = {
        travelers: [],
            shuttles: [],
            hotels: [],
            activities: [],
            rental_cars: [],
            flights: [],
            ferry: []
      }
    },
    clearForm(stepBack=false) {
      this.$v.$reset()
/*      if(!stepBack) this.form.id = null
      this.form.client_name = null
      //this.form.email = null
      //this.form.supplier_name = '...'
      this.form.cc_email = null
      this.form.reply_email = ''
      this.form.sender_name = null
      this.form.supplier = null
      //this.form.supplierid = 0
      this.form.supplier_gender = null*/
/*      this.currentTrip = null
      this.options.currentTrip = null*/
      this.trip = null;
    },
    async save() {
      const self = this;
       let trippi =  await this.loadJsonField('trip_details', this.currentTrip.json_path);
       let contacts = trippi.data.attributes.pax.contact ? trippi.data.attributes.pax.contact : trippi.data.attributes.pax.paxInfo;
       let conString = "";
       if(!trippi.data.attributes.pax.contact){
        contacts.forEach(element =>{
         if(contacts.length == contacts.indexOf(element) + 1)
         {
            let firstname = element.firstName.slice(0, 1).toUpperCase()
            conString += firstname + element.firstName.slice(1).toLowerCase() + " " + element.lastName.toUpperCase()
         }else{
            let firstname = element.firstName.slice(0, 1).toUpperCase()
            conString += firstname + element.firstName.slice(1).toLowerCase() + " " + element.lastName.toUpperCase() + ", "
         }
        })
       }else{
          let firstname = contacts['firstName'].slice(0, 1).toUpperCase()
          conString += contacts['lastName'].toUpperCase() + " " + firstname + contacts['firstName'].slice(1).toLowerCase()
       }

      self.sending = true;
      self.form.message =  self.editor.getHTML();

      self.form.message = self.form.message.replace(/src="([^"]*)"/g, (match, p1) => {
        const cleanedUrl = p1.replace(/[\s\\]+/g, '');
        return `src='${cleanedUrl}' alt='Bild konnte nicht geladen werden'`;
      }).replace(/"/g, "'");
      self.form.subject = self.form.lang === 'de' ? self.BetreffDe : self.BetreffEn;
      self.form.subject = self.form.subject.replaceAll("[id]", self.trip.nezasa_id)
      self.form.subject = self.form.subject.replaceAll("[name]", conString)
      self.form.subject = self.fillSupplierVars(self.form.subject, self.trip_details_json);
      self.form.subject = self.form.subject.replace(/<\/?[^>]+>/ig, " ");
      self.form.sig = self.fillSupplierVars(self.form.lang === 'de' ? self.suppliersig_de : self.suppliersig_en, self.trip_details_json);
      let timestamp = new Date();
      let myTripData = [];
      for (const [key, value] of Object.entries(this.tripDetails)) {
        value.forEach(element =>{
          if(element.check == 1){
            element.categorie = key;
            myTripData.push(element);
          }
        })
      }
      
      self.form.context = "sendTripToSupplier"
      // Backend picks the branding's own From/Reply-To (brandings.sender_*) from this id.
      self.form.branding_id = self.brand || null
      this.form.company = this.company
      this.form.logo = this.logo
      await this.doPost({
        userdata: self.options.user,
        data: self.form
      }, 'sendTripToSupplier', function (res) {
        self.sending = false;
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.showSuccess = true;
          self.$emit('updateData', {});
          self.closeDialog();
        }
      });
      self.form.logo = "";
      let saveTimeline = {
        trip: self.savedOfferID ,
        tripDetails: myTripData,
        firstname: self.options.user.firstname,
        lastname: self.options.user.lastname,
        date: timestamp,
        form: self.form,
        
      }
      self.getTimeline(saveTimeline);
    },
    async getTimeline(saveTimeline){
      let self = this;
      await this.doPost({data: self.savedOfferID }, 'getTimeline', function (res) {
         if (res.data.status === 'error') {
           self.help.log(self.$t(res.msg), false, true);
         } else {
            let toParse = res.data?.data[0]?.timeline || '[]';
            self.fullTimeline.push(JSON.parse(toParse));
            self.fullTimeline[0].push(saveTimeline);
            self.saveTimeline();
         }
       });
    },
    async saveTimeline(){
      let self = this;
            await this.doPost({data: self.fullTimeline}, 'saveTimeline', function (res) {
              if (res.data.status === 'error') {
                self.help.log(self.$t(res.msg), false, true);
              }
            });
    },
    async getKommentare() {
      if(this.trip.nezasa_id){
        let saveData = {
          tripId: this.trip.nezasa_id,
        };
        let self = this;
        self.kommentsFromDb = []
        await self.doPost({ data: saveData }, "getKommentare", function (res) {
          if (res.data.status === "error") {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            let result = res.data.data;
            self.kommentsFromDb = result;
          }
        });
      }
      else{
        window.setTimeout(() => {
          this.getKommentare();
        }, 1000);
      }
        
      },
    async getTripDetails() {
      await this.getItineraryDetails()
      await this.getAccoDetails()
      let self = this;
      self.accoCheck = 0;
      let tripDetails = await this.loadJsonField(['trip_details', 'trip_details_en', 'itinerary_details', 'itinerary_details_en'], this.currentTrip.json_path);
      const _trip = self.form.lang === 'en' ? tripDetails.trip_details_en : tripDetails.trip_details;
      const _itinerary = self.form.lang === 'en' ? tripDetails.itinerary_details_en : tripDetails.itinerary_details;
      const _travelers = _trip.data.attributes.pax.paxInfo
      if (Array.isArray(_travelers)) {
        _travelers.forEach((t, i) => {
          self.tripDetails.travelers.push({
            name: t.firstName + ' ' + t.lastName,
            gender: t.gender,
            birthday: moment(t.birthDate).format('DD. MM. YYYY') != moment().format('DD. MM. YYYY') ? moment(t.birthDate).format('DD. MM. YYYY') : "---",
          })
        })
      }
      const legs = _itinerary?.itinerary?.modules?.[0]?.legs;
      if (Array.isArray(legs)) {
        legs.forEach((t, i) => {
          const stop = t;
          if (Array.isArray(stop?.connections)) {
            stop.connections.forEach(connection => {
              if (connection?.transferType === 'CarFerry') {
                self.tripDetails.ferry.push({
                  name: connection.name,
                  startDate: moment.parseZone(connection.startDateTime).format('DD. MM YYYY HH:mm'),
                  endDate: moment.parseZone(connection.endDateTime).format('DD. MM YYYY HH:mm'),
                });
              }
            });
          }
        });
      }
      await _trip.included.forEach((t, i) => {
        const tripDetails = t.attributes
        switch (tripDetails.type) {
          case 'internationalFlight' :
            for (let i = 0; i < tripDetails.legs.length; i++) {
              self.tripDetails.flights.push({
                id: t?.id ? t?.id + tripDetails.legs[i].segments[0].departureName + ' - ' + tripDetails.legs[i].segments[(tripDetails.legs[i].segments.length - 1)].arrivalName : "",
                name: tripDetails.legs[i].segments[0].departureName + ' - ' + tripDetails.legs[i].segments[(tripDetails.legs[i].segments.length - 1)].arrivalName,
                duration: t.attributes.duration,
                //vendor: tripDetails.legs[i].externalReference.source,
                vendor: '',
                dayStart: moment.parseZone(tripDetails.legs[i].segments[0].departureDateTime).format('DD. MMM YYYY HH:mm'),
                dayEnd: moment.parseZone(tripDetails.legs[i].segments[tripDetails.legs[i].segments.length - 1].arrivalDateTime).format('DD. MMM YYYY HH:mm'),
                class: tripDetails.legs[i].segments[0].flightClass,
                airline: tripDetails.legs[i].segments[0].airline,
                code: tripDetails.legs[i].segments[0].airlineCode + tripDetails.legs[i].segments[0].flightNumber,
                check: 0,
              })
            }
            break;
      
          case 'accommodation' :
          if(self.form.lang === 'en'){
            self.accoLanguage = self.accoDetailsEn;
          }else{
            self.accoLanguage = self.accoDetails;
          }
          self.accoLanguage?.forEach(element =>{
            if(element?.attributes?.amenities)
            {
              element.attributes.amenities.forEach(ane =>[
                ane.longDescription = ""
              ])
            }else if(element?.amenities){
              element.amenities.forEach(ane =>[
                ane.longDescription = ""
              ])
            }
          })

          let currentAccommodationAmenities = '';
          const productRefId = tripDetails.productRefId;
          if (productRefId && self.accoLanguage) {
            const matchingAccommodation = self.accoLanguage.find(acco =>
              acco?.attributes?.refId === productRefId
            );
            if (matchingAccommodation?.attributes?.amenities) {
              currentAccommodationAmenities = matchingAccommodation.attributes.amenities;
            }
          }

            self.tripDetails.hotels.push({
              id: t?.id ? t?.id : "",
              pax: tripDetails?.room && tripDetails?.room?.paxInfo && tripDetails?.room?.paxInfo[0] ? tripDetails?.room?.paxInfo : "noPax",
              name: moment.parseZone(tripDetails.startDateTime).format('DD. MMM YYYY') + ' - ' + moment.parseZone(tripDetails.endDateTime).format('DD. MMM YYYY') + ' ' + tripDetails.desc,
              vendor: tripDetails.supplier ? tripDetails.supplier.name ? tripDetails.supplier.name : tripDetails.supplier.id : "No Supplier",
              check: 0,
              room: tripDetails?.room && tripDetails?.room?.desc && tripDetails?.room?.desc != "" ? tripDetails?.room?.desc : "",
              city: tripDetails && tripDetails?.startLocation?.city ? tripDetails.startLocation.city : '',
              zusatz: currentAccommodationAmenities,
              zusatzCheck: false
            })

            // DEBUG: Log what was actually assigned
            const lastHotel = self.tripDetails.hotels[self.tripDetails.hotels.length - 1];
            this.accoCheck++;
            break;
          case 'activity' :
            self.tripDetails.activities.push({
              id: t?.id ? t?.id : "",
              name: tripDetails.desc,
              date: moment.parseZone(tripDetails.startDateTime).format('DD. MMM YYYY HH:mm') + ' - ' + moment.parseZone(tripDetails.endDateTime).format('DD. MMM YYYY HH:mm'),
              vendor: tripDetails?.supplier?.name ? tripDetails?.supplier?.name : tripDetails?.supplier?.id,
              check: 0,
            })
            break;
          case 'rental-car' :
            self.tripDetails.rental_cars.push({
              id: t?.id ? t?.id : "",
              name: tripDetails.desc + ' ' + ( tripDetails.acriss.transmissionCode === 'M' ? 'Manuell' : 'Automatik'),
              date: moment.parseZone(tripDetails.pickupDate).format('DD. MMM YYYY HH:mm') + ' ' + tripDetails.pickupLocation + ' - ' + moment.parseZone(tripDetails.dropoffDate).format('DD. MMM YYYY HH:mm') + ' ' +  tripDetails.dropoffLocation,
              vendor: tripDetails.supplier.name ? tripDetails.supplier.name : tripDetails.supplier.id,
              check: 0,
            })
            break;
          default:
        }
      })


      if (self.mails.length > 0) {
        //////////////////////////////////////////////////////////////////////////////
        if (self?.tripDetails?.flights?.length > 0) {
          for (let i = 0; i < self.tripDetails.flights.length; i++) {
            let hotel = self.tripDetails.flights[i];


            for (let j = 0; j < self.mails.length; j++) {
              let mail = self.mails[j];

              if (mail?.tripDetails?.length > 0) {
    
                for (let k = 0; k < mail.tripDetails.length; k++) {
                  let anfrage = mail.tripDetails[k];
                 
                  if (anfrage.id == hotel.id) {
                   
                    hotel.anfrage = true;
                  }
                }
              }
            }
          }
        } else {
        }
        //////////////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////////////
        if (self?.tripDetails?.hotels?.length > 0) {
          for (let i = 0; i < self.tripDetails.hotels.length; i++) {
            let hotel = self.tripDetails.hotels[i];

            if(self.kommentsFromDb?.length > 0){
              self.kommentsFromDb.forEach(kommi =>{
                if(kommi.comp_id == hotel.id){
                  hotel.kommi = kommi.text
                }
              })
            }

            for (let j = 0; j < self.mails.length; j++) {
              let mail = self.mails[j];

              if (mail?.tripDetails?.length > 0) {
    
                for (let k = 0; k < mail.tripDetails.length; k++) {
                  let anfrage = mail.tripDetails[k];
                 
                  if (anfrage.id == hotel.id) {
                   
                    hotel.anfrage = true;
                  }
                }
              }
            }
          }
        }
        if (self?.tripDetails?.activities?.length > 0) {
          for (let i = 0; i < self.tripDetails.activities.length; i++) {
            let hotel = self.tripDetails.activities[i];

            if(self.kommentsFromDb?.length > 0){
              self.kommentsFromDb.forEach(kommi =>{
                if(kommi.comp_id == hotel.id){
                  hotel.kommi = kommi.text
                }
              })
            }


            for (let j = 0; j < self.mails.length; j++) {
              let mail = self.mails[j];

              if (mail?.tripDetails?.length > 0) {
    
                for (let k = 0; k < mail.tripDetails.length; k++) {
                  let anfrage = mail.tripDetails[k];
                 
                  if (anfrage.id == hotel.id) {
                   
                    hotel.anfrage = true;
                  }
                }
              }
            }
          }
        }
        if (self?.tripDetails?.rental_cars?.length > 0) {
          for (let i = 0; i < self.tripDetails.rental_cars.length; i++) {
            let hotel = self.tripDetails.rental_cars[i];

            if(self.kommentsFromDb?.length > 0){
              self.kommentsFromDb.forEach(kommi =>{
                if(kommi.comp_id == hotel.id){
                  hotel.kommi = kommi.text
                }
              })
            }

            for (let j = 0; j < self.mails.length; j++) {
              let mail = self.mails[j];

              if (mail?.tripDetails?.length > 0) {
    
                for (let k = 0; k < mail.tripDetails.length; k++) {
                  let anfrage = mail.tripDetails[k];
                 
                  if (anfrage.id == hotel.id) {
                   
                    hotel.anfrage = true;
                  }
                }
              }
            }
          }
        }
      }
      if (self?.tripDetails?.hotels?.length > 0) {
        for (let i = 0; i < self.tripDetails.hotels.length; i++) {
          let hotel = self.tripDetails.hotels[i];

          if(self.kommentsFromDb?.length > 0){
            self.kommentsFromDb.forEach(kommi =>{
              if(kommi.comp_id == hotel.id){
                hotel.kommi = kommi.text
              }
            })
          }
        }
      }
      if (self?.tripDetails?.activities?.length > 0) {
        for (let i = 0; i < self.tripDetails.activities.length; i++) {
          let hotel = self.tripDetails.activities[i];

          if(self.kommentsFromDb?.length > 0){
            self.kommentsFromDb.forEach(kommi =>{
              if(kommi.comp_id == hotel.id){
                hotel.kommi = kommi.text
              }
            })
          }
        }
      }
      if (self?.tripDetails?.rental_cars?.length > 0) {
        for (let i = 0; i < self.tripDetails.rental_cars.length; i++) {
          let hotel = self.tripDetails.rental_cars[i];
          if(self.kommentsFromDb?.length > 0){
            self.kommentsFromDb.forEach(kommi =>{
              if(kommi.comp_id == hotel.id){
                hotel.kommi = kommi.text
              }
            })
          }
        }
      }
      if(self.tripDetails?.hotels?.length > 0){
        self.tripDetails?.hotels.forEach(hotel =>{
          if(hotel?.zusatz?.length > 0){
            hotel.zusatzCheck = true; // Set to true if amenities exist
            // Remove the unnecessary inclusionPolicy check that was preventing display
          }
        })
      }
      await this.$nextTick();
      this.renderComponent = true;
    },
    async closeEmail() {
      this.openMail = false;
      
      this.puffer = this.tripDetails 

      let button = document.getElementById("sendButton")
      button.removeAttribute("disabled")

    },
    async langSwitched(){
      this.checkedList = {
        flights: this.tripDetails.flights.filter(x => x.check === 1).map(x => x.id),
        hotels: this.tripDetails.hotels.filter(x => x.check === 1).map(x => x.id),
        rental_cars: this.tripDetails.rental_cars.filter(x => x.check === 1).map(x => x.id),
        activities: this.tripDetails.activities.filter(x => x.check === 1).map(x => x.id),
        ferry: this.tripDetails.ferry.filter(x => x.check === 1).map(x => x.id),
        shuttles: this.tripDetails.shuttles.filter(x => x.check === 1).map(x => x.id)
      };

      await this.clearTripdetails()
      await this.getKommentare();
      await this.getTripDetails()
      await this.getFullTrip()
      await this.openEmail();
    },
    async setSupplier(event) {
     
      const _supplier = this.suppliers.find(x => x.id === event.id);
      this.form.email = _supplier.email;
      this.form.supplier = _supplier.supplier_name;
      this.form.supplierid = _supplier.id;

      this.form.supplier_gender = _supplier.gender;
      this.form.supplier_name = _supplier.lastname
      await this.getEmail()
    },
    openEmail() {
      this.go = true;
      this.openMail = true;
      this.getEmail()
    },
    getAllSuppliersForEmail() {
      let self = this;
      this.doPost({userdata: self.options.user}, 'getAllSuppliers', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.responseToTableData(res.data.data, self.cols).then(values => {
            self.suppliers = values;
          })
        }
        self.options.isUploading = false;
        self.isLoaded = true;
      });
    },
    restoreChecked(list, checkedIds) {
      if (!Array.isArray(list) || !Array.isArray(checkedIds)) return;

      list.forEach(item => {
        if (checkedIds.includes(item.id)) {
          item.check = 1;
        }
      });
    },
    async getEmail() {
      let self = this;
      //self.form.reply_email = self.reply
    
      let checkFlight = 0;
      let checkHotel = 0;
      let checkRentalCar = 0;
      let checkActivities = 0;
      let checkShuttle = 0;
      let checkFerry = 0;
      // Restore previously selected items
      if (this.checkedList) {
        this.restoreChecked(this.tripDetails?.flights, this.checkedList?.flights);
        this.restoreChecked(this.tripDetails?.hotels, this.checkedList?.hotels);
        this.restoreChecked(this.tripDetails?.rental_cars, this.checkedList?.rental_cars);
        this.restoreChecked(this.tripDetails?.activities, this.checkedList?.activities);
        this.restoreChecked(this.tripDetails?.ferry, this.checkedList?.ferry);
        this.restoreChecked(this.tripDetails?.shuttles, this.checkedList?.shuttles);
      }
      this.email = '';
      if (this.form.lang === 'de') {
        this.email += 'Sehr geehrte::r Kollege';
        this.email += ', bitte senden Sie uns ein unverbindliches Angebot für die folgenden Leistungen:';

        ///////////////////////////
        let trip_info = await this.loadJsonField(['trip_details', 'trip_details_en'], this.currentTrip.json_path);
        let paxinfo = this.form.lang === 'en' ? trip_info.trip_details_en : trip_info.trip_details
        paxinfo = paxinfo?.data?.attributes?.pax;
        if(paxinfo?.contact && (paxinfo?.contact?.phone != "" && paxinfo?.contact?.phone != undefined || paxinfo?.contact?.email != "" && paxinfo?.contact?.email != undefined)){
          this.email += '</br></br>';
          this.email += "Kontaktinformationen:";
          this.email += '</br></br>';
          this.email += paxinfo?.contact?.firstName != "" && paxinfo?.contact?.lastName != "" ? `Name: ${paxinfo?.contact?.firstName + " " + paxinfo?.contact?.lastName + "</br>"}` : "";
          this.email += paxinfo?.contact?.phone != "" && paxinfo?.contact?.phone != undefined ? `Telefon: ${paxinfo?.contact?.phone + "</br>"}` : "";
          this.email += paxinfo?.contact?.email != "" && paxinfo?.contact?.email != undefined ? `Email: ${paxinfo?.contact?.email + "</br>"}` : "";

        }
        ///////////////////////////

        this.email += '</br></br>';
        this.email += 'Reisende::r / Kunde::in: ';
        for (let i = 0; i < this.tripDetails.travelers.length; i++) {
          if(this.tripDetails.travelers[i]?.name && this.tripDetails.travelers[i].birthday && this.tripDetails.travelers[i].gender){
            this.email += '</br></br>';
          this.email += this.tripDetails.travelers[i].name + '</br>';
          this.email += this.tripDetails.travelers[i].birthday + '</br>';
          this.email += this.tripDetails.travelers[i].gender === 'Male' ? 'Männlich' : 'Weiblich';
          }
          
        }
      } else {
        this.email += 'Dear colleagues';
        this.email += ', herewith we would like to request the following services for the customers:';

        ///////////////////////////
        let trip_info = await this.loadJsonField(['trip_details', 'trip_details_en'], this.currentTrip.json_path);
        let paxinfo = this.form.lang === 'en' ? trip_info.trip_details_en : trip_info.trip_details
        paxinfo = paxinfo?.data?.attributes?.pax;
        if(paxinfo?.contact && (paxinfo?.contact?.phone != "" && paxinfo?.contact?.phone != undefined || paxinfo?.contact?.email != "" && paxinfo?.contact?.email != undefined)){
          this.email += '</br></br>';
          this.email += "contact details:";
          this.email += '</br></br>';
          this.email += paxinfo?.contact?.firstName != "" && paxinfo?.contact?.lastName != "" ? `name: ${paxinfo?.contact?.firstName + " " + paxinfo?.contact?.lastName + "</br>"}` : "";
          this.email += paxinfo?.contact?.phone != "" && paxinfo?.contact?.phone != undefined ? `phone: ${paxinfo?.contact?.phone + "</br>"}` : "";
          this.email += paxinfo?.contact?.email != "" && paxinfo?.contact?.email != undefined ? `email: ${paxinfo?.contact?.email + "</br>"}` : "";

        }
        ///////////////////////////

        this.email += '</br></br>';
        this.email += 'Traveler / Client: ';
        for (let i = 0; i < this.tripDetails.travelers.length; i++) {
          if(this.tripDetails.travelers[i]?.name && this.tripDetails.travelers[i].birthday && this.tripDetails.travelers[i].gender){
            this.email += '</br></br>';
          this.email += this.tripDetails.travelers[i].name + '</br>';
          this.email += this.tripDetails.travelers[i].birthday + '</br>';
          this.email += this.tripDetails.travelers[i].gender;
          }
          
        }
      }
      this.email += '</br></br>';
      this.email += '<br/><br/>';
      if (this.tripDetails.flights.length > 0) {
        for (let i = 0; i < this.tripDetails.flights.length; i++) {
          if (this.tripDetails.flights[i].check) {
            if(checkFlight === 0){
              this.email += this.form.lang === 'de' ? '<b>Flüge:</b>' : '<b>Flights:</b>';
              this.email += '<br/><br/>';
              checkFlight++;
            }
            this.email += this.tripDetails.flights[i].name;
            this.email += '<br/>';
            this.email += this.tripDetails.flights[i].dayStart + ' - ' + this.tripDetails.flights[i].dayEnd + ' ' + this.tripDetails.flights[i].airline + ' ' + this.tripDetails.flights[i].code + ' ' + this.tripDetails.flights[i].class;
            this.email += '<br/><br/>';
          }
        }
      }
      if (this.tripDetails.hotels.length > 0) {

        for (let i = 0; i < this.tripDetails.hotels.length; i++) {
          if (this.tripDetails.hotels[i].check) {
            if(checkHotel === 0){
              this.email += this.form.lang === 'de' ? '<b>Hotels:</b>' : '<b>Hotels:</b>';
              this.email += '<br/><br/>';
              checkHotel++;
            }
            this.email += this.tripDetails.hotels[i].name;
            this.email += `<br/>${this.tripDetails.hotels[i].city}`;
            this.email += '<br/>';
          

            if(this.tripDetails.hotels[i]?.room && this.tripDetails.hotels[i]?.room != ""){
              this.email += this.form.lang === 'de' ? `<b>Zimmer: ${this.tripDetails.hotels[i]?.room}</b>` : `<b>room: ${this.tripDetails.hotels[i]?.room}</b>`;
              this.email += '<br/>';
            }

            if(this.tripDetails.hotels[i].zusatzCheck == true){
              if(this.tripDetails.hotels[i].zusatz && this.tripDetails.hotels[i].zusatz[0]){
                this.email += this.form.lang === 'de' ? 'Zusatzleistungen' : 'amenities';
                this.email += '<br/>';
                this.tripDetails.hotels[i].zusatz.forEach(element=>{
                // if(element?.inclusionPolicy != 'OptionalExcluded'){
                  this.email += element.name;
                  this.email += '<br/>';
                //}
              })
            }
            }

            if(this.tripDetails.hotels[i].kommi){
                this.email += '<br/>';
                this.email += this.form.lang === 'de' ? 'Kommentar:' : 'comment:';
                this.email += this.tripDetails.hotels[i].kommi
            }
            
            
            


            this.email += '<br/><br/>';
          }
        }
      }
      if (this.tripDetails.rental_cars.length > 0) {
        for (let i = 0; i < this.tripDetails.rental_cars.length; i++) {
          if (this.tripDetails.rental_cars[i].check) {
            if(checkRentalCar === 0){
              this.email += this.form.lang === 'de' ? '<b>Mietwagen:</b>' : '<b>Rental cars:</b>';
              this.email += '<br/><br/>';
              checkRentalCar++;
            }
            this.email += this.tripDetails.rental_cars[i].name;
            this.email += '<br/>';
            this.email += this.tripDetails.rental_cars[i].date;
            this.email += '<br/><br/>';
          }
          if(this.tripDetails.rental_cars[i].kommi){
                this.email += '<br/>';
                this.email += this.form.lang === 'de' ? 'Kommentar:' : 'comment:';
                this.email += this.tripDetails.rental_cars[i].kommi
                this.email += '<br/><br/>'
            }
        }
      }
      if (this.tripDetails.shuttles.length > 0) {
        for (let i = 0; i < this.tripDetails.shuttles.length; i++) {
          if (this.tripDetails.shuttles[i].check) {
            if(checkShuttle === 0){
              this.email += this.form.lang === 'de' ? '<b>Transporte:</b>' : '<b>Shuttles:</b>';
              this.email += '<br/><br/>';
              checkShuttle++;
            }
            this.email += this.tripDetails.shuttles[i].name;
            this.email += '<br/><br/>';
          }

        }
      }
      if (this.tripDetails.ferry.length > 0) {
        for (let i = 0; i < this.tripDetails.ferry.length; i++) {
          if (this.tripDetails.ferry[i].check) {
            if(checkFerry === 0){
              this.email += this.form.lang === 'de' ? '<b>Fähren:</b>' : '<b>Ferries:</b>';
              this.email += '<br/><br/>';
              checkFerry++;
            }
            this.email += `${this.tripDetails.ferry[i].name}<br/>${this.tripDetails.ferry[i].startDate} - ${this.tripDetails.ferry[i].endDate}`;
            this.email += '<br/><br/>';
          }

        }
      }
      if (this.tripDetails.activities.length > 0) {
        for (let i = 0; i < this.tripDetails.activities.length; i++) {
          if (this.tripDetails.activities[i].check) {
            if(checkActivities === 0){
              this.email += this.form.lang === 'de' ? '<b>Aktivitäten:</b>' : '<b>Activities:</b>';
              this.email += '<br/><br/>';
              checkActivities++;
            }
            this.email += this.tripDetails.activities[i].name;
            this.email += '<br/>';
            this.email += this.tripDetails.activities[i].date;
            this.email += '<br/><br/>';
          }
          if(this.tripDetails.activities[i].kommi){
                this.email += '<br/>';
                this.email += this.form.lang === 'de' ? 'Kommentar:' : 'comment:';
                this.email += this.tripDetails.activities[i].kommi
            }
        }
      }
      this.email += '<br/><br/>';
      this.email += this.fillSupplierVars(this.form.lang === 'de' ? this.suppliersig_de : this.suppliersig_en, this.trip_details_json);
      this.editor.commands.setContent(self.email);
    },
    openDialog() {

    },
    closeDialog() {
      this.clearForm();
      this.options.showSendEmailToSupplierForm = false;
      this.trip = null;
      this.options.currentTrip = null;
      this.options.userSendEmailToSupplierEditable = true;
    },
    validate() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.save()
      }
    },
    moment(date){
      return moment(date)
    }
  }
}
</script>

<style lang="scss">
@use '../../assets/style/FormSendTripToSupplier/main.scss';
@use '../../assets/style/FormSendTripToSupplier/steps.scss';
.supplier-field-right{
  padding-left: 5px;
}
.supplier-field-left{
  padding-right: 5px;
}
</style>
